import { render, staticRenderFns } from "./DiagnosticOrderModal.vue?vue&type=template&id=71c485fe&"
import script from "./DiagnosticOrderModal.vue?vue&type=script&lang=js&"
export * from "./DiagnosticOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports